import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const EditorJSError = ({
  user: { role, companyname, avatar, firstname, lastname, jobtitle, location },
  setShowArticleError,
  articleError,
}) => {
  return (
    <Fragment>
      {role === "innovator" && (
        <div className="messages-overlay">
          <div className="request-box">
            <i
              className="fas fa-times fa-3x message-x"
              onClick={() => setShowArticleError({ show: false, text: "" })}
            ></i>
            <div className="flex-center">
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="drop-down-result-avi"
                    alt="avatar"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font bold">
                      {firstname} {lastname}
                    </span>
                  </li>
                  <li className="user-online-item">{jobtitle}</li>
                  <li className="user-online-item">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
            <div className="user-request-text">
              <i className="fas fa-exclamation-circle fa-lg red mr-5"></i>
              {articleError.text}
            </div>
            <div className="flex-center">
              <button
                className="user-request-button background-green"
                onClick={() => setShowArticleError({ show: false, text: "" })}
              >
                <i className="fas fa-times fa-sm mr-5"></i>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {role === "mentor" && (
        <div className="messages-overlay">
          <div className="request-box">
            <i
              className="fas fa-times fa-3x message-x"
              onClick={() => setShowArticleError({ show: false, text: "" })}
            ></i>
            <div className="flex-center">
              <div className="online-avi-container">
                <div className="avi-color-border red">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="drop-down-result-avi"
                    alt="red-avatar"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="red name-font bold">
                      {firstname} {lastname}
                    </span>
                  </li>
                  <li className="user-online-item">{jobtitle}</li>
                  <li className="user-online-item">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
            <div className="user-request-text">
              <i className="fas fa-exclamation-circle fa-lg red mr-5"></i>
              {articleError.text}
            </div>
            <div className="flex-center">
              <button
                className="user-request-button background-red"
                onClick={() => setShowArticleError({ show: false, text: "" })}
              >
                <i className="fas fa-times fa-sm mr-5"></i>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {role === "employer" && (
        <div className="messages-overlay">
          <div className="request-box">
            <i
              className="fas fa-times fa-3x message-x"
              onClick={() => setShowArticleError({ show: false, text: "" })}
            ></i>
            <div className="flex-center">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                    className="drop-down-result-avi"
                    alt="blue-avatar"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font bold">{companyname}</span>
                  </li>
                  <li className="user-online-item">
                    {firstname} {lastname}
                  </li>
                  <li className="user-online-item">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
            <div className="user-request-text">
              <i className="fas fa-exclamation-circle fa-lg red mr-5"></i>
              {articleError.text}
            </div>
            <div className="flex-center">
              <button
                className="user-request-button background-blue"
                onClick={() => setShowArticleError({ show: false, text: "" })}
              >
                <i className="fas fa-times fa-sm mr-5"></i>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

EditorJSError.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(EditorJSError);
